import React from 'react'

interface Props {
  size?: string
}

const Logo: React.FC<Props> = ({ size = 'large' }): JSX.Element => {
  if (size === 'large') {
    return (
      <>
        <svg
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          className='marketware-logo text-gray-black pr-3'
          width='175px'
          x='0px'
          y='0px'
          viewBox='0 0 1008 180'
          xml-space='preserve'
        >
          <g>
            <path
              fill='currentColor'
              d='M372.3,130.6h-14.8V73L331,107.5h-4.9l-26.5-34.7v57.8H285V37.2h5l38.6,51.4l38.7-51.4h5L372.3,130.6
		L372.3,130.6z'
            />
            <path
              fill='currentColor'
              d='M415.4,60.7c4.2,0,8,0.6,11.4,1.8s6.4,3,8.8,5.4c2.5,2.4,4.4,5.3,5.8,8.9s2.1,7.7,2.1,12.5v41.4h-13.6V123
		c-2.4,2.9-5.5,5.1-9.2,6.8c-3.7,1.6-7.9,2.4-12.7,2.4c-3.6,0-6.9-0.5-9.8-1.4s-5.4-2.3-7.5-4c-2.1-1.8-3.7-3.9-4.8-6.3
		c-1.1-2.4-1.7-5.1-1.7-8.1c0-6,2.3-10.8,6.8-14.3s10.7-5.2,18.4-5.2h19.4v-4.5c0-4.7-1.3-8.4-3.8-10.9s-6.1-3.8-10.9-3.8
		c-4,0-7.5,0.9-10.4,2.6c-3,1.8-5.8,4.3-8.6,7.5l-8.4-8.6c3.5-5,7.7-8.7,12.7-11.1C404.3,61.9,409.7,60.7,415.4,60.7z M411.1,120.9
		c2.4,0,4.7-0.4,6.8-1.2c2.1-0.8,4-1.9,5.6-3.3s2.9-3.2,3.8-5.2s1.4-4.2,1.4-6.5v-1.3h-17.5c-3.9,0-6.9,0.7-9,2.1s-3.1,3.5-3.1,6.3
		c0,3,1.2,5.2,3.5,6.8C404.9,120.1,407.8,120.9,411.1,120.9z'
            />
            <path
              fill='currentColor'
              d='M490.5,61.6c1.2,0,2.3,0.1,3.1,0.2c0.9,0.1,1.7,0.3,2.4,0.5v12.9h-4.5c-2.7,0-5.3,0.4-7.7,1.2
		c-2.5,0.8-4.6,2-6.4,3.6s-3.3,3.6-4.3,5.9c-1.1,2.4-1.6,5.1-1.6,8.3v36.5H457V62.3h13.5v9.2c2.4-3.2,5.4-5.7,8.8-7.4
		C482.8,62.4,486.5,61.6,490.5,61.6z'
            />
            <path
              fill='currentColor'
              d='M522.9,130.6h-14.6V34.8h14.6V130.6z M538.2,92.5l27.7,38.2h-18.2L521,92.3l26.7-29.9h18.2L538.2,92.5z'
            />
            <path
              fill='currentColor'
              d='M601.4,60.7c4.5,0,8.8,0.8,12.7,2.4s7.2,3.8,10,6.5c2.8,2.8,5,6.1,6.5,10c1.6,3.9,2.4,8,2.4,12.5
		c0,1.9-0.1,3.6-0.3,5.3c-0.2,1.7-0.5,3-0.8,3.9h-51c1,5.7,3.5,10.1,7.5,13.2c4,3.2,8.9,4.7,14.8,4.7c4,0,7.6-0.7,10.9-2.2
		c3.2-1.4,6.3-3.4,9.1-5.9l7.1,10c-3.6,3.4-7.7,6.1-12.3,8.1c-4.5,1.9-9.6,2.9-15,2.9c-5.3,0-10.2-0.9-14.8-2.7
		c-4.5-1.8-8.4-4.3-11.7-7.5s-5.8-7-7.7-11.3c-1.9-4.4-2.8-9.1-2.8-14.1s0.9-9.7,2.7-14.1s4.3-8.1,7.5-11.3
		c3.2-3.2,6.9-5.7,11.2-7.6C591.8,61.7,596.4,60.7,601.4,60.7z M601,73.1c-5,0-9.3,1.5-12.8,4.5s-5.8,7.1-7,12.2h37.2
		c-0.2-5.4-2-9.5-5.4-12.4C609.6,74.6,605.6,73.1,601,73.1z'
            />
            <path
              fill='currentColor'
              d='M688.5,74.9H668v32.2c0,4.5,1.2,7.7,3.6,9.3c2.4,1.7,5.7,2.5,10.1,2.5c1.2,0,2.6-0.1,4-0.2
		c1.5-0.1,3.1-0.3,4.9-0.5v12.4c-1.9,0.5-3.7,0.8-5.6,1.1c-1.9,0.3-4,0.4-6.3,0.4c-7.6,0-13.7-1.9-18.3-5.7s-6.9-9.8-6.9-18.1V74.9
		h-11.1V62.3h11.1V41.9H668v20.4h20.5V74.9z'
            />
            <path
              fill='currentColor'
              d='M774.6,106.5l15.3-44.3h15.5l-27.8,69.9h-5L751,88.9l-19,43.3h-5l-30.4-69.9h15.6l18,44.7l18.3-46.2h5
		L774.6,106.5z'
            />
            <path
              fill='currentColor'
              d='M841.2,60.7c4.2,0,8,0.6,11.4,1.8s6.4,3,8.8,5.4c2.5,2.4,4.4,5.3,5.8,8.9c1.4,3.6,2.1,7.7,2.1,12.5v41.4h-13.6
		V123c-2.4,2.9-5.5,5.1-9.2,6.8c-3.7,1.6-7.9,2.4-12.7,2.4c-3.6,0-6.9-0.5-9.8-1.4c-2.9-0.9-5.4-2.3-7.5-4c-2.1-1.8-3.7-3.9-4.8-6.3
		s-1.7-5.1-1.7-8.1c0-6,2.3-10.8,6.8-14.3s10.7-5.2,18.4-5.2h19.4v-4.5c0-4.7-1.3-8.4-3.8-10.9s-6.1-3.8-10.9-3.8
		c-4,0-7.5,0.9-10.4,2.6c-3,1.8-5.8,4.3-8.6,7.5l-8.4-8.6c3.5-5,7.7-8.7,12.7-11.1C830.1,61.9,835.4,60.7,841.2,60.7z M836.9,120.9
		c2.4,0,4.7-0.4,6.8-1.2c2.1-0.8,4-1.9,5.6-3.3s2.9-3.2,3.8-5.2c0.9-2,1.4-4.2,1.4-6.5v-1.3H837c-3.9,0-6.9,0.7-9,2.1
		s-3.1,3.5-3.1,6.3c0,3,1.2,5.2,3.5,6.8C830.7,120.1,833.5,120.9,836.9,120.9z'
            />
            <path
              fill='currentColor'
              d='M917.5,61.6c1.2,0,2.2,0.1,3.1,0.2c0.9,0.1,1.7,0.3,2.4,0.5v12.9h-4.5c-2.7,0-5.3,0.4-7.7,1.2
		c-2.5,0.8-4.6,2-6.4,3.6c-1.8,1.6-3.3,3.6-4.3,5.9c-1.1,2.4-1.6,5.1-1.6,8.3v36.5h-14.6V62.3h13.5v9.2c2.4-3.2,5.4-5.7,8.8-7.4
		C909.7,62.4,913.5,61.6,917.5,61.6z'
            />
            <path
              fill='currentColor'
              d='M963.7,60.7c4.5,0,8.8,0.8,12.7,2.4s7.2,3.8,10,6.5c2.8,2.8,5,6.1,6.5,10c1.6,3.9,2.4,8,2.4,12.5
		c0,1.9-0.1,3.6-0.3,5.3c-0.2,1.7-0.5,3-0.8,3.9h-51c1,5.7,3.5,10.1,7.5,13.2c4,3.2,8.9,4.7,14.8,4.7c4,0,7.6-0.7,10.9-2.2
		c3.2-1.4,6.3-3.4,9.1-5.9l7.1,10c-3.6,3.4-7.7,6.1-12.3,8.1c-4.5,1.9-9.6,2.9-15,2.9c-5.3,0-10.2-0.9-14.8-2.7
		c-4.5-1.8-8.4-4.3-11.7-7.5s-5.8-7-7.7-11.3c-1.9-4.4-2.8-9.1-2.8-14.1s0.9-9.7,2.7-14.1s4.3-8.1,7.5-11.3
		c3.2-3.2,6.9-5.7,11.2-7.6C954,61.7,958.7,60.7,963.7,60.7z M963.3,73.1c-5,0-9.3,1.5-12.8,4.5s-5.8,7.1-7,12.2h37.2
		c-0.2-5.4-2-9.5-5.4-12.4C971.9,74.6,967.9,73.1,963.3,73.1z'
            />
          </g>
          <g>
            <g>
              <linearGradient
                id='logogradient'
                gradientUnits='userSpaceOnUse'
                x1='12.725'
                y1='621.45'
                x2='265.275'
                y2='621.45'
                gradientTransform='matrix(1 0 0 1 0 -538)'
              >
                <stop offset='0' stopColor='#5C2E8B' />
                <stop offset='1' stopColor='#1DB0E6' />
              </linearGradient>
              <path
                fill="url('#logogradient')"
                d='M162.9,81.4L162.9,81.4c-2.1-2.1-2.1-5.4,0-7.4l26.7-26.7c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4
			l-26.7,26.7C168.3,83.5,164.9,83.5,162.9,81.4z M209.4,75.7l4.3-4.3c2.1-2.1,2.1-5.4,0-7.4l0,0c-2.1-2.1-5.4-2.1-7.4,0l-4.3,4.3
			c-2.1,2.1-2.1,5.4,0,7.4l0,0C204,77.7,207.3,77.7,209.4,75.7z M43.2,108.6l64.9-64.9c2.1-2.1,2.1-5.4,0-7.4l0,0
			c-2.1-2.1-5.4-2.1-7.4,0l-64.9,64.9c-2.1,2.1-2.1,5.4,0,7.4l0,0C37.8,110.7,41.2,110.7,43.2,108.6z M30.9,113.5L30.9,113.5
			c2.1,2.1,2.1,5.4,0,7.4l-9.2,9.2c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l9.2-9.2C25.5,111.4,28.9,111.4,30.9,113.5z
			 M47.6,130.1L47.6,130.1c-2.1-2.1-2.1-5.4,0-7.4L117.3,53c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4L55,130.1
			C53,132.2,49.7,132.2,47.6,130.1z M147.4,130.2L147.4,130.2c-2.1-2.1-2.1-5.4,0-7.4l19.9-19.9c2.1-2.1,5.4-2.1,7.4,0l0,0
			c2.1,2.1,2.1,5.4,0,7.4l-19.9,19.9C152.8,132.3,149.4,132.3,147.4,130.2z M215,129.2L215,129.2c-2.1-2.1-2.1-5.4,0-7.4l24.5-24.5
			c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4l-24.5,24.5C220.4,131.2,217.1,131.2,215,129.2z M247.1,130.6L247.1,130.6
			c-2.1-2.1-2.1-5.4,0-7.4l9.2-9.2c2.1-2.1,5.4-2.1,7.4,0l0,0c2.1,2.1,2.1,5.4,0,7.4l-9.2,9.2C252.4,132.7,249.1,132.7,247.1,130.6z
			 M158.1,86.3L158.1,86.3c2.1,2.1,2.1,5.4,0,7.4l-36.5,36.5c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l36.5-36.5
			C152.7,84.2,156,84.2,158.1,86.3z M196.2,114.7L196.2,114.7c-2.1-2.1-2.1-5.4,0-7.4l26.7-26.7c2.1-2.1,5.4-2.1,7.4,0l0,0
			c2.1,2.1,2.1,5.4,0,7.4l-26.7,26.7C201.6,116.8,198.2,116.8,196.2,114.7z M191.4,119.6L191.4,119.6c2.1,2.1,2.1,5.4,0,7.4
			l-3.4,3.4c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l3.4-3.4C186,117.5,189.3,117.5,191.4,119.6z M197.1,80.5L197.1,80.5
			c2.1,2.1,2.1,5.4,0,7.4L187,98.1c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4l10.1-10.1C191.7,78.5,195.1,78.5,197.1,80.5z
			 M114.1,97L114.1,97c2.1,2.1,2.1,5.4,0,7.4l-25.4,25.4c-2.1,2.1-5.4,2.1-7.4,0l0,0c-2.1-2.1-2.1-5.4,0-7.4L106.6,97
			C108.7,94.9,112,94.9,114.1,97z M118.9,92.1L118.9,92.1c-2.1-2.1-2.1-5.4,0-7.4L134,69.6c2.1-2.1,5.4-2.1,7.4,0l0,0
			c2.1,2.1,2.1,5.4,0,7.4l-15.1,15.1C124.3,94.2,121,94.2,118.9,92.1z'
              />
            </g>
          </g>
        </svg>
      </>
    )
  } else if (size === 'small') {
    return (
      <>
        <svg
          className='marketware-logo-mark text-blue hover:text-blue-sky transition duration-300 ease-out'
          width='48'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlns-xlink='http://www.w3.org/1999/xlink'
          x='0px'
          y='0px'
          viewBox='0 0 500 220'
          xml-space='preserve'
        >
          <path
            fill='currentColor'
            d='M292.3,101.1L292.3,101.1c-3.8-3.8-3.8-10,0-13.8L341.7,38c3.8-3.8,10-3.8,13.8,0l0,0c3.8,3.8,3.8,10,0,13.8
	l-49.3,49.3C302.3,104.9,296.1,104.9,292.3,101.1z M378.3,90.4l7.9-7.9c3.8-3.8,3.8-10,0-13.8l0,0c-3.8-3.8-10-3.8-13.8,0l-7.9,7.9
	c-3.8,3.8-3.8,10,0,13.8l0,0C368.3,94.2,374.5,94.2,378.3,90.4z M71.1,151.4L191.1,31.4c3.8-3.8,3.8-10,0-13.8l0,0
	c-3.8-3.8-10-3.8-13.8,0L57.4,137.6c-3.8,3.8-3.8,10,0,13.8l0,0C61.2,155.2,67.3,155.2,71.1,151.4z M48.4,160.3L48.4,160.3
	c3.8,3.8,3.8,10,0,13.8l-17.1,17.1c-3.8,3.8-10,3.8-13.8,0l0,0c-3.8-3.8-3.8-10,0-13.8l17.1-17.1C38.5,156.5,44.6,156.5,48.4,160.3z
	 M79.2,191.1L79.2,191.1c-3.8-3.8-3.8-10,0-13.8L208.1,48.5c3.8-3.8,10-3.8,13.8,0l0,0c3.8,3.8,3.8,10,0,13.8L93,191.1
	C89.2,194.9,83,194.9,79.2,191.1z M263.7,191.3L263.7,191.3c-3.8-3.8-3.8-10,0-13.8l36.8-36.8c3.8-3.8,10-3.8,13.8,0l0,0
	c3.8,3.8,3.8,10,0,13.8l-36.8,36.8C273.6,195.1,267.5,195.1,263.7,191.3z M388.7,189.3L388.7,189.3c-3.8-3.8-3.8-10,0-13.8
	l45.3-45.3c3.8-3.8,10-3.8,13.8,0l0,0c3.8,3.8,3.8,10,0,13.8l-45.3,45.3C398.7,193.1,392.5,193.1,388.7,189.3z M447.9,192L447.9,192
	c-3.8-3.8-3.8-10,0-13.8l17-17c3.8-3.8,10-3.8,13.8,0l0,0c3.8,3.8,3.8,10,0,13.8l-17,17C457.9,195.8,451.7,195.8,447.9,192z
	 M283.4,110L283.4,110c3.8,3.8,3.8,10,0,13.8L216,191.2c-3.8,3.8-10,3.8-13.8,0l0,0c-3.8-3.8-3.8-10,0-13.8l67.4-67.4
	C273.4,106.2,279.6,106.2,283.4,110z M353.9,162.6L353.9,162.6c-3.8-3.8-3.8-10,0-13.8l49.3-49.3c3.8-3.8,10-3.8,13.8,0l0,0
	c3.8,3.8,3.8,10,0,13.8l-49.3,49.3C363.9,166.4,357.7,166.4,353.9,162.6z M344.9,171.6L344.9,171.6c3.8,3.8,3.8,10,0,13.8l-6.4,6.4
	c-3.8,3.8-10,3.8-13.8,0l0,0c-3.8-3.8-3.8-10,0-13.8l6.4-6.4C335,167.8,341.1,167.8,344.9,171.6z M355.6,99.4L355.6,99.4
	c3.8,3.8,3.8,10,0,13.8l-18.7,18.7c-3.8,3.8-10,3.8-13.8,0l0,0c-3.8-3.8-3.8-10,0-13.8l18.7-18.7C345.6,95.6,351.8,95.6,355.6,99.4z
	 M202.1,129.8L202.1,129.8c3.8,3.8,3.8,10,0,13.8l-46.9,46.9c-3.8,3.8-10,3.8-13.8,0l0,0c-3.8-3.8-3.8-10,0-13.8l46.9-46.9
	C192.1,126,198.3,126,202.1,129.8z M211,120.8L211,120.8c-3.8-3.8-3.8-10,0-13.8l27.8-27.8c3.8-3.8,10-3.8,13.8,0l0,0
	c3.8,3.8,3.8,10,0,13.8l-27.8,27.8C221,124.6,214.8,124.6,211,120.8z'
          />
        </svg>
      </>
    )
  }
}

export default Logo
